<template>
    <div class="text-a-brown-502314" :class="{ 'pt-4 mb-6': !parentIsCollapsible }">
        <template v-if="label != ''">
            <div class="label text-14 lg:text-base mb-6">
                <span class="font-bold">{{ label }}</span>
                <span v-if="isOptional" class="text-a-brown-9f8273 text-12 lg:text-14 font-bold ml-1">({{ lblOptional
                }})</span>
            </div>
        </template>
        <div class="controls grid grid-cols-2 gap-4">
            <template v-for="(item, idx) of items" :key="`rad-item-${idx}`">
                <div class="cursor-pointer flex items-center" @click="onClickItem(item)">
                    <div class="flex-none">
                        <img class="w-5 h-auto" v-show="!isSelected(item)"
                            src="@/assets/icon/ic-uncheckbox-brown.svg" />
                        <img class="w-5 h-auto" v-show="isSelected(item)" src="@/assets/icon/ic-checkbox-red.svg" />
                    </div>
                    <div class="flex-auto text-14 lg:text-base ml-2">
                        <span class="flex-none" :class="[isSelected(item) ? 'text-a-red-d62300' : '']">{{ item[textKey]
                        }}</span>
                        <span class="text-12 lg:text-14 text-a-red-d62300  ml-1">{{ price(item) }}</span>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import { inject, onMounted } from 'vue'

export default {
    name: 'CheckboxGroup',
    props: {
        modelValue: {
            type: Array,
        },
        label: {
            type: String,
            default: ""
        },
        items: {
            type: Array,
            default: () => []
        },
        dataSelected: {
            type: Array,
            default: () => []
        },
        isRequired: {
            type: Boolean,
            default: false
        },
        valueKey: {
            type: String,
            default: 'value'
        },
        textKey: {
            type: String,
            default: "text"
        },
        parentIsCollapsible: {
            type: Boolean,
            default: false
        },
        isOptional: {
            type: Boolean,
            default: false
        },
        defaultAll: {
            type: Boolean
        },
        excepList: {
            type: Array,
            default: () => []
        }
    },
    components: {},
    mixins: [],
    emits: ["update:modelValue", "update:unselectedList"],
    data: function () { return {} },
    setup: function (props, context) {
        const { lbl } = inject("LocaleStore")
        const lblOptional = lbl.value.productDetail.optional
        const isSelected = function (item) {
            if (props.modelValue != null && props.modelValue.length > 0) {
                let existsIdx = props.modelValue.findIndex(x => {
                    return x[props.valueKey] == item[props.valueKey]
                })
                if (existsIdx > -1) {
                    return true
                }
            }

            return false
        }

        const onClickItem = function (item) {
            let rawList = [...props.modelValue]
            let existsIdx
            if(rawList.length == 0){
                rawList.push(item)
                existsIdx = rawList.findIndex(x => x[props.valueKey] == item[props.valueKey])
            }else {
                existsIdx = rawList.findIndex(x => x[props.valueKey] == item[props.valueKey])
                if (existsIdx > -1) {
                    // remove
                    rawList.splice(existsIdx, 1)
                }
                else {
                    rawList.push(item)
                }
            }
            context.emit("update:modelValue", rawList)
            context.emit("update:unselectedList", {item, existsIdx})
        }

        const price = (item) => {
            let price = item?.pricePerUnit ?? 0
            if (price > 0) {
                return `+${price} ${lbl.value.productDetail.priceUnit}`
            } else {
                return ""
            }
        }

        onMounted(() => {
            if (props.defaultAll) {
                let selectedItems = []
                for (const item of props.items) {
                    // check excepList if exist then skip this item
                    let except = props.excepList.findIndex(x => {
                        return x[props.valueKey] == item[props.valueKey]
                    })
                    if (except > -1) continue

                    selectedItems.push(item)
                }
                if(props.dataSelected.length > 0) {
                    const filteredArray = props.items.filter(
                        (item1) => !props.dataSelected.some((item2) => item2.id === item1.id)
                    );
                    selectedItems = filteredArray
                }
                context.emit("update:modelValue", selectedItems)
            }else {
                // optional
                if(props.dataSelected.length > 0) {
                    const filteredArray = props.items.filter(
                        (item1) => props.dataSelected.some((item2) => item2.campaign_id === item1.id)
                    );
                    context.emit("update:modelValue", filteredArray)
                }else {
                    context.emit("update:modelValue", [])
                }
            }
        })

        return {
            isSelected,
            onClickItem,
            lblOptional,
            price
        }
    },
    mounted: function () { },
    methods: {}
}
</script>
